import React from 'react';
import { cn } from '../ui/cn';
import { PRIMARY_NAV, MORE_TAB, SECONDARY_NAV } from './navItems';

/**
 * Mobile bottom tab bar (< lg). Four tabs: Properties · Searches · Opportunities · More.
 * "More" is highlighted when the current page is one of the secondary destinations.
 */
const BottomNav = ({ currentPage, onNavigate, onOpenMore, opportunityCount = 0, moreOpen = false }) => {
  const secondaryIds = SECONDARY_NAV.map((i) => i.id);
  const tabs = [...PRIMARY_NAV, MORE_TAB];

  return (
    <nav
      data-testid="bottom-nav"
      aria-label="Primary"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-sidebar border-t border-[#1B3F4D] pb-safe"
    >
      <ul className="grid grid-cols-4 h-bottomnav">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isMore = tab.id === 'more';
          const isActive = isMore ? moreOpen || secondaryIds.includes(currentPage) : currentPage === tab.id;
          const badge = tab.badgeKey === 'opportunities' ? opportunityCount : 0;
          return (
            <li key={tab.id} className="min-w-0">
              <button
                type="button"
                onClick={() => (isMore ? onOpenMore() : onNavigate(tab.id))}
                aria-current={isActive && !isMore ? 'page' : undefined}
                aria-label={tab.label}
                className={cn(
                  'relative w-full h-full flex flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors',
                  isActive ? 'text-accent' : 'text-[#8FB0BA] active:text-primary'
                )}
              >
                <span className="relative">
                  <Icon className="w-6 h-6" />
                  {badge > 0 && (
                    <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full bg-danger text-white text-[10px] font-semibold flex items-center justify-center tabular">
                      {badge}
                    </span>
                  )}
                </span>
                <span className="truncate max-w-full px-1">{tab.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BottomNav;
